var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"InputSigarusCheckboxList"},[_c('el-checkbox-group',{model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}},_vm._l((_vm.list),function(item,i){return _c('el-checkbox',{key:i,attrs:{"label":item.value}},[_vm._v(_vm._s(item.label))])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }